import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    signal,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RevampSelectGeneralApplicationComponent } from 'app/modules/landing/corporate/revamp-select-general-application/revamp-select-general-application.component';
import { parseJSON, scrollToFirstInvalidControl } from 'app/shared/utils';
import { ToastrService } from 'ngx-toastr';
import { RevampInputGeneralApplicationComponent } from 'app/modules/landing/corporate/revamp-input-general-application/revamp-input-general-application.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DashboardService } from 'app/modules/dashboard/dashboard.service';
import { AuthService } from 'app/auth/auth.service';
import { EncryptionService } from 'app/services/encryption.service';
import { ForbiddenCharsDirective } from 'app/shared/forbidden-chars.directive';

@Component({
    selector: 'app-business-info-settings',
    standalone: true,
    imports: [
        TranslateModule,
        CommonModule,
        MatIconModule,
        MatDividerModule,
        RevampSelectGeneralApplicationComponent,
        RevampInputGeneralApplicationComponent,
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        FooterComponent,
        HeaderComponent,
        MatCheckboxModule,
        RouterModule,
        MatDividerModule,
        RevampInputGeneralApplicationComponent,
        RevampSelectGeneralApplicationComponent,
        MatExpansionModule,
        MatCardModule,
        SlickCarouselModule,
        ForbiddenCharsDirective,
    ],
    templateUrl: './business-info-settings.component.html',
    styleUrl: './business-info-settings.component.scss',
})
export class BusinessInfoSettingsComponent {
    productName: string;
    caseId: any;
    businessProfileForm: FormGroup;
    isRequired: any;
    submitted: boolean = false;
    businessIndustry: string = '';
    numberOfYearsOperation: any;
    profitRecentSelected: any = '';
    howDoYouKnowAboutIMSME: string = '';
    isDraft: any;
    productFlowData;
    toggleDropDown = [false, false, false, false];
    isAuthenticated: boolean = false;
    @ViewChild('formContainer') formContainer!: ElementRef;
    minAnnualSalesTurnover: string;
    businessIndustryOptions = [
        {
            value: '1',
            label: 'COMMON.ELECTRICITY_GAS_WATER',
        },
        {
            value: '2',
            label: 'COMMON.AGRICULTURE_FORESTRY_FISHING',
        },
        {
            value: '3',
            label: 'COMMON.MINING_QUARRYING',
        },
        {
            value: '4',
            label: 'COMMON.MANUFACTURING',
        },
        {
            value: '5',
            label: 'COMMON.TRANSPORT_STORAGE_COMMUNICATION',
        },
        {
            value: '6',
            label: 'COMMON.FINANCING_INSURANCE_REAL_ESTATE_BUSINESS_SERVICE',
        },
        {
            value: '7',
            label: 'COMMON.CONSTRUCTION',
        },
        {
            value: '8',
            label: 'COMMON.WHOLESALE_RETAIL_TRADE_RESTAURANTS_HOTELS',
        },
        {
            value: '9',
            label: 'COMMON.OTHER_SERVICES',
        },
        {
            value: '10',
            label: 'COMMON.TOURISM',
        },
    ];

    // numberOfYearsOperationOptions = [
    //     {
    //         value: 5,
    //         label: 'LESS_THAN_6_MONTHS',
    //     },
    //     {
    //         value: 6,
    //         label: '6_MONTHS_LESS_THAN_1_YEAR',
    //     },
    //     {
    //         value: 12,
    //         label: '1_YEAR_TO_LESS_THAN_2_YEARS',
    //     },
    //     {
    //         value: 24,
    //         label: '2_YEAR_TO_LESS_THAN_3_YEARS',
    //     },
    //     {
    //         value: 36,
    //         label: '3_YEAR_TO_LESS_THAN_4_YEARS',
    //     },
    //     {
    //         value: 48,
    //         label: '4_YEAR_AND_ABOVE',
    //     },
    // ];

    numberOfYearsOperationOptions = [
        {
            value: 0.5,
            label: 'LESS_THAN_6_MONTHS',
        },
        {
            value: 0.6,
            label: '6_MONTHS_LESS_THAN_1_YEAR',
        },
        {
            value: 1,
            label: '1_YEAR_TO_LESS_THAN_2_YEARS',
        },
        {
            value: 2,
            label: '2_YEAR_TO_LESS_THAN_3_YEARS',
        },
        {
            value: 3,
            label: '3_YEAR_TO_LESS_THAN_4_YEARS',
        },
        {
            value: 4,
            label: '4_YEAR_AND_ABOVE',
        },
    ];

    maxCompanyName = 50;
    maxCompanyAddress = 50;
    maxNoOfEmployee = 3;

    isSelectError: string;

    businessType: string = '';
    businessTypeOptions = [
        {
            value: 'SP',
            label: 'COMMON.SOLE_PROPRIETORSHIP',
        },
        {
            value: 'PN',
            label: 'COMMON.PARTNERSHIP',
        },
        {
            value: 'LLP',
            label: 'COMMON.LIMITED_LIABILITY',
        },
        {
            value: 'SDNBHD',
            label: 'COMMON.SDNBHD',
        },
        {
            value: 'PROFBODIES',
            label: 'COMMON.PROFESSIONAL_SERVICE_PROVIDER',
        },
        {
            value: 'IND',
            label: 'COMMON.INDIVIDUAL',
        },
    ];

    yesNoOptions = [
        {
            value: 'Yes',
            label: 'FINANCING_STEPS.SABAH_SARAWAK_OR_BUMIPUTERA_YES',
        },
        {
            value: 'No',
            label: 'FINANCING_STEPS.SABAH_SARAWAK_OR_BUMIPUTERA_NO',
        },
    ];
    yesNoOptionType: string = '';

    clickedOutside: boolean = false;
    inputError: string;
    selectionError: string;
    selectionError2: string;
    companyNameInputError: string;
    companyAddressInputError: string;
    companyContactInputError: string;
    companyContactMinMaxError: string;
    emailInputError: string;
    emailPatternError: string;
    noOfEmployeeInputError: string;
    closeTostr: string;
    disableSubmitBtn: boolean = false;
    selectedLanguage: any;

    value = 35;
    isFocus: boolean = false;
    panelOpenState = signal(true);
    currentSlide: number = 0;

    rightSide = [
        {
            title: 'RIGHT_DIV.TITLE_1',
            subtitle: 'RIGHT_DIV.SUBTITLE_1',
        },
        {
            title: 'RIGHT_DIV.TITLE_2',
            subtitle: 'RIGHT_DIV.SUBTITLE_2',
        },
        {
            title: 'RIGHT_DIV.TITLE_3',
            subtitle: 'RIGHT_DIV.SUBTITLE_3',
        },
    ];
    userData: any;
    originalProfileData: any = {};
    isEditing = false;
    fieldsToEnableDisable = [
        'companyName',
        'companyAddress',
        'companyContactDetails',
        'companyEmail',
        'businessType',
        'sabahSarwak',
        'businessIndustry',
        'yearsOfOperation',
        'noOfEmployee',
    ];

    constructor(
        private fb: FormBuilder,
        private _dashService: DashboardService,
        private authService: AuthService,
        private encryptionService: EncryptionService,
        private translate: TranslateService,
        private toastr: ToastrService
    ) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        this.userData = this._dashService.getUser();
    }

    ngOnInit() {
        this.selectedLanguage = localStorage.getItem('language');
        this.updateTranslation();

        this.businessProfileForm = this.fb.group({
            companyName: [{ value: '', disabled: true }, [Validators.required]],
            companyAddress: [
                { value: '', disabled: true },
                [Validators.required],
            ],
            companyContactDetails: [
                { value: '', disabled: true },
                [
                    Validators.required,
                    Validators.minLength(9),
                    Validators.maxLength(10),
                ],
            ],
            companyEmail: [
                { value: '', disabled: true },
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-z0-9._-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
                    ),
                    Validators.minLength(6),
                    Validators.maxLength(254),
                ],
            ],
            businessType: [
                { value: '', disabled: true },
                [Validators.required],
            ],
            sabahSarwak: [{ value: '', disabled: true }, [Validators.required]],
            businessIndustry: [
                { value: '', disabled: true },
                [Validators.required],
            ],
            yearsOfOperation: [
                { value: '', disabled: true },
                [Validators.required],
            ],
            noOfEmployee: [
                { value: '', disabled: true },
                [Validators.required],
            ],
        });
        this.setFormValues(this.userData);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes['close'].currentValue == true ||
            (changes['close'].previousValue == true &&
                changes['close'].currentValue == false)
        ) {
            this.closeDropdown();
        }
    }

    get f() {
        return this.businessProfileForm.controls;
    }

    setFormValues(data: any) {
        if (data) {
            const details = data?.details;
            this.businessType = details?.testconsttype;
            this.businessIndustry = details?.entitytype;
            this.numberOfYearsOperation = details?.yearsinoperation;
            if (details?.yearsinoperation != null) {
                this.handleNumberOfYearsOperationDetail(
                    Number(details?.yearsinoperation)
                );
            }

            this.yesNoOptionType = this.mapOptionValue(details?.sabah) || '';

            let noOfEmployeeValue;
            if (details?.fulltimeemployees || details?.fulltimeemployees == 0) {
                noOfEmployeeValue = details.fulltimeemployees;
            } else {
                noOfEmployeeValue = '';
            }

            this.businessProfileForm.patchValue({
                companyName: details?.bizname || '',
                companyAddress: details?.address || '',
                companyContactDetails: details?.companycontactdetails || '',
                companyEmail: details?.companyemail || '',
                businessType: details?.testconsttype || '',
                sabahSarwak: this.yesNoOptionType,
                businessIndustry: details?.entitytype || '',
                yearsOfOperation: details?.yearsinoperation || '',
                noOfEmployee: noOfEmployeeValue,
            });
        }
    }

    mapOptionValue(value: any): any {
        if (value == null) {
            return null;
        } else {
            return value === 'y' ? 'Yes' : 'No';
        }
    }

    onSelectSabahSarwak(value: any) {
        this.yesNoOptionType = value;
        this.businessProfileForm.patchValue({
            sabahSarwak: this.yesNoOptionType,
        });
    }

    updateTranslation() {
        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });

        this.translate
            .get('NEW_APPLICATION.FINANCING_INFO_COMMON_ERROR')
            .subscribe((data: any) => {
                this.selectionError = data;
            });

        this.translate.get('ERROR.COMPANY_NAME').subscribe((data: any) => {
            this.companyNameInputError = data;
        });

        this.translate
            .get('ERROR.COMPANY_ADDRESS_ERROR')
            .subscribe((data: any) => {
                this.companyAddressInputError = data;
            });

        this.translate
            .get('ERROR.COMPANY_CONTACT_ERROR')
            .subscribe((data: any) => {
                this.companyContactInputError = data;
            });

        this.translate
            .get('ERROR.BUSINESS_INFO_SELECT')
            .subscribe((data: any) => {
                this.selectionError2 = data;
            });

        this.translate.get('ERROR.EMAIL_REQUIRED').subscribe((data: any) => {
            this.emailInputError = data;
        });

        this.translate
            .get('ERROR.INVALID_EMAIL_ENTERED')
            .subscribe((data: any) => {
                this.emailPatternError = data;
            });

        this.translate
            .get('ERROR.COMPANY_CONTACT_MIN_MAX')
            .subscribe((data: any) => {
                this.companyContactMinMaxError = data;
            });

        this.translate
            .get('ERROR.NO_OF_EMPLOYEE_ERROR')
            .subscribe((data: any) => {
                this.noOfEmployeeInputError = data;
            });

        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.translate
            .get('ERROR.BUSINESS_INFO_SELECT')
            .subscribe((data: any) => {
                this.isSelectError = data;
            });

        this.translate
            .get('ERROR.BUSINESS_INFO_INPUT')
            .subscribe((data: any) => {
                this.inputError = data;
            });
    }

    handleBusinessTypeOptions(value: any) {
        this.businessType = value;
        this.businessProfileForm.patchValue({
            businessType: this.businessType,
        });
    }

    closeAllDropdowns(state: number) {
        for (let i = 0; i < 4; i++) {
            if (i != state) {
                this.toggleDropDown[i] = false;
            } else {
                this.toggleDropDown[i] = true;
            }
        }
        event.stopPropagation();
    }

    closeDropdown() {
        for (let i = 0; i < 4; i++) {
            this.toggleDropDown[i] = false;
        }
    }

    countCharacter(str: string, char: string): number {
        const regex = new RegExp(char, 'g');
        const matches = str.match(regex);
        return matches ? matches.length : 0;
    }

    keyPressNumbers(event, isAmount?) {
        const element = event.target as HTMLInputElement;
        const inputValue = element.value;
        let numericValue = '';
        const initialCommas = this.countCharacter(inputValue, ',');
        let selectionStart = element.selectionStart || 0;
        const isBackspace = event.inputType === 'deleteContentBackward'; // Check if the backspace key was pressed

        if (isAmount) {
            const rawValue = inputValue.replace(/[^0-9]/g, '');
            if (rawValue === '') {
                return (event.target.value = null);
            }

            numericValue = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            numericValue = `RM${numericValue}`;

            // Adjust cursor position
            const addedCharacters = numericValue.length - inputValue.length;

            if (isBackspace) {
                const prevChar = inputValue[selectionStart - 1];
            } else {
                const prevChar = inputValue[selectionStart - 1];
                if (prevChar === ',' || prevChar === 'R') {
                    selectionStart += addedCharacters - 1;
                } else {
                    selectionStart += addedCharacters;
                }
            }
        } else {
            numericValue = inputValue.replace(/[^0-9]/g, '');
            if (numericValue == '' || inputValue == '') {
                this.businessProfileForm.controls.noOfEmployee.patchValue(null);
            }
        }
        const finalCommas = this.countCharacter(numericValue, ',');
        if (isBackspace && finalCommas < initialCommas) {
            selectionStart -= 1;
        }
        element.value = numericValue;
        const finalCursorPos = Math.min(selectionStart, numericValue.length);
        element.setSelectionRange(finalCursorPos, finalCursorPos);
    }

    pasteNumberOnly(event) {
        let clipboardData = event.clipboardData;
        let pastedData = clipboardData.getData('Text');

        if (isNaN(pastedData)) {
            event.preventDefault();
        } else {
            return;
        }
    }

    getErrors(input: any): Array<any> {
        this.updateTranslation();
        let errors = [];
        const lengthConstraints: {
            [key: string]: { min: number; max: number; errorMsg: string };
        } = {
            companyEmail: {
                min: 6,
                max: 254,
                errorMsg: this.emailPatternError,
            },
            companyContactDetails: {
                min: 9,
                max: 10,
                errorMsg: this.companyContactMinMaxError,
            },
        };
        if (this.submitted) {
            const fieldErrors = this.f[input].errors;
            if (fieldErrors?.required) {
                // Optional: Add select-specific errors here
                errors.push(this.getCustomErrorMessage(input));
            }
            if (
                (this.f[input].errors?.minlength ||
                    this.f[input].errors?.maxlength) &&
                lengthConstraints[input]
            ) {
                if (!errors.includes(lengthConstraints[input].errorMsg)) {
                    errors.push(lengthConstraints[input].errorMsg);
                }
            }

            if (this.f[input].value && this.f[input].errors?.pattern) {
                if (!errors.includes(this.emailPatternError)) {
                    errors.push(this.emailPatternError);
                }
            }
        }
        return errors;
    }

    getCustomErrorMessage(input: string): string {
        switch (input) {
            case 'companyName':
                return this.companyNameInputError;
            case 'companyAddress':
                return this.companyAddressInputError;
            case 'companyContactDetails':
                return this.companyContactInputError;
            case 'companyEmail':
                return this.emailInputError;
            case 'businessType':
                return this.selectionError;
            case 'sabahSarwak':
                return this.selectionError;
            case 'businessIndustry':
                return this.selectionError;
            case 'yearsOfOperation':
                return this.selectionError;
            case 'noOfEmployee':
                return this.noOfEmployeeInputError;
            default:
                return 'This field is required';
        }
    }

    handleBusinessIndustryOptions(value: any) {
        this.businessIndustry = value;
        this.businessProfileForm.patchValue({
            businessIndustry: this.businessIndustry,
        });
    }

    handleNumberOfYearsOperationDetail(val: any) {
        this.numberOfYearsOperation = val;
        this.businessProfileForm.patchValue({
            yearsOfOperation: this.numberOfYearsOperation,
        });
    }

    onSubmit(event, data) {
        this.closeDropdown();

        let isSabahSarwak;
        if (this.businessProfileForm.value.sabahSarwak === 'Yes') {
            isSabahSarwak = 'y';
        } else if (this.businessProfileForm.value.sabahSarwak === 'No') {
            isSabahSarwak = 'n';
        }

        let noOfEmployeeValue = parseInt(data.noOfEmployee);

        let objReq = {
            details: {
                bizname: data.companyName,
                address: data.companyAddress,
                companycontactdetails: data.companyContactDetails,
                companyemail: data.companyEmail,
                testconsttype: data.businessType,
                sabah: isSabahSarwak,
                entitytype: data.businessIndustry,
                yearsinoperation: data.yearsOfOperation,
                fulltimeemployees: noOfEmployeeValue,
            },
        };

        if (this.businessProfileForm.invalid) {
            scrollToFirstInvalidControl(this.formContainer.nativeElement);
        }
        this.submitted = true;

        if (this.businessProfileForm.valid) {
            this.onSubmitBusinessInfo(objReq);
        } else {
            return;
        }
    }

    onSubmitBusinessInfo(objReq) {
        this.updateTranslation();
        this.disableSubmitBtn = true;

        this.authService.updateProfile(objReq).subscribe({
            next: (res) => {
                this.disableSubmitBtn = false;
                let msg: string;
                let currLang = localStorage.getItem('language');
                if (currLang == 'bm') {
                    msg = 'Butiran perniagaan anda telah berjaya dikemas kini';
                } else {
                    msg =
                        'Your business info details have been successfully updated';
                }
                this.toastr.success(msg);
                this.isEditing = false;
                this.fieldsToEnableDisable.forEach((field) =>
                    this.businessProfileForm.get(field)?.disable()
                );
                const encryptionKey = atob(localStorage.getItem('cepn'));
                localStorage.setItem(
                    'profile',
                    this.encryptionService.encryptData(
                        btoa(JSON.stringify(res)), // passing the response obejct `res` to the encryption service::KSK
                        encryptionKey
                    )
                );
            },
            error: (err) => {
                this.disableSubmitBtn = false;
                let error = parseJSON(err.error);
                this.toastr.error(error.message);
            },
        });
    }

    onEditBusinessInfo() {
        this.isEditing = true;
        this.originalProfileData = this.businessProfileForm.getRawValue();
        this.fieldsToEnableDisable.forEach((field) =>
            this.businessProfileForm.get(field)?.enable()
        );
    }

    onCancelBusInfoDetails() {
        this.isEditing = false;
        // Restore original data
        this.businessProfileForm.patchValue(this.originalProfileData);
        // Re-disable editable fields
        this.fieldsToEnableDisable.forEach((field) =>
            this.businessProfileForm.get(field)?.disable()
        );
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    onFocus() {
        this.isFocus = true;
    }

    onBlur() {
        this.isFocus = false;
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }
}
